import { render, staticRenderFns } from "./CustomerDialog.vue?vue&type=template&id=19e433be"
import script from "./CustomerDialog.vue?vue&type=script&lang=ts"
export * from "./CustomerDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports